// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import materielProfileLayout from './TypeLocalProfileLayout';

import TypeLocalService from '../../services/TypeLocalService';

const DeleteTypeLocal = () => {
	const [typeLocal, setTypeLocal] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([TypeLocalService.getTypeLocal(id)]).then(([typeLocalData]) => {
			setTypeLocal(typeLocalData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the TypeLocalService to delete the TypeLocal
			await TypeLocalService.deleteTypeLocal(id);

			// Redirect the user to the list of TypeLocals
			navigate('/assets/typelocal');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression du Type de Local ",
				error
			);
		}
	};

	return (
		<materielProfileLayout>
			{typeLocal && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{typeLocal.type || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement Type de Local.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez ce Type de Local, toutes les données le concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le materiel
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</materielProfileLayout>
	);
};

export default DeleteTypeLocal;
